// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f310856b","732":"afce2fea","977":"f1a1d393"}[chunkId] + ".chunk.js";
};